import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/dudak-dolgusu-sonrasi-opusme-bilimsel-estetik-ve-duygusal-bir-rehber/page.tsx");
